import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VatNumberComponent } from './vat-number.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [VatNumberComponent],
  exports:[VatNumberComponent],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class VatNumberModule { }
